<template>

  <tr>
    <td class="text-truncate"><router-link :to="{path: '/job/' + value._id }">{{ value.title }}</router-link> #{{ value.code }}</td>
    <td class="text-truncate">{{ statusName }}</td>
    <td class="text-truncate">{{ value.openings }}</td>
    <td class="text-truncate">{{ $d(new Date(value.update_status_date), 'short') }}</td>
    <td class="text-truncate">{{ $n(value.remuneration || 0, {style: 'currency', currency: value.currency}) }}</td>
    <td class="text-truncate">{{ $n(value.remuneration_max || 0, {style: 'currency', currency: value.currency}) }}</td>
    <td class="text-truncate">{{ remunerationPeriod }}</td>
    <td class="text-truncate">{{ $d(new Date(value.date_open), 'short') }}</td>
    <td class="text-truncate">{{ $d(new Date(value.date_close), 'short') }}</td>
    <td class="text-truncate">{{ value.country }}</td>
    <td class="text-truncate">{{ value.region }}</td>
    <td class="text-truncate">{{ value.city }}</td>
    <td class="text-truncate">{{ value.neighborhood }}</td>
    <td class="text-truncate">{{ value.address }}</td>
    <td class="text-truncate">{{ value.zipcode }}</td>
    <td class="text-truncate">{{ $t(value.workplace_type) }}</td>
    <td class="text-truncate">{{ value.hiring_manager_name }}</td>
    <td class="text-truncate">{{ value.hiring_manager_email }}</td>
    <td class="text-truncate">{{ value.company.name }}</td>
    <td class="text-truncate">{{ value.departament.name }}</td>
    <td class="text-truncate">{{ value.contract.name }}</td>
    <td class="text-truncate">{{ value.owner_user.name }}</td>
    <td class="text-truncate">{{ position_category }}</td>
    <td class="text-truncate">{{ experience_level }}</td>
    <td class="text-truncate">{{ education_degree }}</td>
    <td class="text-truncate">{{ value.total_candidates }}</td>
    <td class="text-truncate">{{ value.total_hireds }}</td>
    <td class="text-truncate">{{ value.cancel_reason ? value.cancel_reason.name : null }}</td>
    <td class="text-truncate">{{ $d(new Date(value.created_at), 'short') }}</td>
  </tr>

</template>

<script>
export default {
  name: 'ListItem',
  props: [
    'value'
  ],
  data () {
    return {
    }
  },
  computed: {
    resources () {
      return this.$store.getters.getResources
    },
    statusName () {
      return {
        open: this.$t('Open'),
        archived: this.$t('Archived')
      }[this.value.status]
    },
    remunerationPeriod () {
      return {
        hour: this.$t('Hour'),
        month: this.$t('Month'),
        year: this.$t('Year')
      }[this.value.remuneration_period]
    },
    position_category () {
      const value = this.resources.position_category.find((val) => {
        return val.key === this.value.position_category
      })
      return value ? value.name : ''
    },
    experience_level () {
      const value = this.resources.experience_level.find((val) => {
        return val.key === this.value.experience_level
      })
      return value ? value.name : ''
    },
    education_degree () {
      const value = this.resources.education_degree.find((val) => {
        return val.key === this.value.education_degree
      })
      return value ? value.name : ''
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Report/ReportJobDetails/ListItem.vue